import React from "react";

import { translateWithoutContext } from "@redux/modules/value/translations/translations.helpers";

type productGroupTitleComponentProps = {
    icon: string;
    title: string;
    isMiniCart: boolean;
    storeFullName?: string;
    isClickAndCollect: boolean;
};

const ProductGroupTitleComponent = ({
    icon,
    title,
    isMiniCart,
    storeFullName,
    isClickAndCollect = false,
}: productGroupTitleComponentProps) => {
    let productGroupTitle = (
        <>
            <h3 className="bg-light-gray py-3 px-2 m-0">
                <i className={`las ${icon} la-lg mr-1`} />
                {translateWithoutContext(title)}
            </h3>
            {isClickAndCollect && !!storeFullName && (
                <p className="mt-2 mb-0">
                    {translateWithoutContext(
                        "general.cart.label.currentStore",
                        storeFullName,
                    )}
                </p>
            )}
        </>
    );

    if (isMiniCart) {
        productGroupTitle = (
            <div className="heading-5 bg-light-gray py-1 px-2 mb-0">
                <i className={`las ${icon} la-lg mr-1`} />
                {translateWithoutContext(title)}
            </div>
        );
    }

    return productGroupTitle;
};

export default ProductGroupTitleComponent;
